<template>
    <div>
        <input-text
            class="mb-2"
            v-model="event.title"
        >
            {{ $t('bookings.eventTitle') }}
        </input-text>
        <input-text
            class="mb-2"
            v-model="event.description"
        >
            {{ $t('bookings.eventDescription') }}
        </input-text>
        <input-text
            class="mb-2"
            v-model="event.supervisor"
        >
            {{ $t('bookings.eventSupervisor') }}
        </input-text>
        <input-text
            class="mb-2"
            v-model="event.phone"
        >
            {{ $t('bookings.eventPhoneNumber') }}
        </input-text>
        <input-text
            class="mb-2"
            type="number"
            v-model="event.person"
        >
            {{ $t('bookings.eventPersonNumber') }} - max. {{ this.room?.persons }}
        </input-text>
    </div>
</template>

<script>
import InputText from "./UI/InputText.vue";

export default {
    name: "ConferenceRoomEventDetailsInput",
    components: {InputText},

    props: {
        value: {},
        room : null,
    },

    data: (vm) => ({
        event: vm.value,
    }),

    watch: {
        event: {
            handler(newVal, oldVal) {
                this.$emit('input', newVal);
            },
            deep: true // Enables deep watching
        }
    },
}
</script>

<style scoped>

</style>
